/**
 * Bridge Minos XOTiny cart to Shiprocket Smart Cart (preview / live parity).
 */
(function () {
  'use strict';

  var SMART_CART_WAIT_MS = 15000;
  var SMART_CART_POLL_MS = 200;

  var TC_SR_BARK = '#4a2f23';
  var TC_SR_ON_BARK = '#fbf8f3';
  var TC_SR_BODY_LIGHT = '#f9f7f2';
  var TC_SR_MUTED = '#9a9086';
  var TC_SR_SALE_CHIP_BG = 'rgba(43,31,21,.82)';
  var TC_SR_SALE_CHIP_TEXT = '#e9c87a';
  var TC_SR_FONT_BODY = "'Manrope',system-ui,sans-serif";
  var TC_SR_FONT_DISPLAY = "'Cormorant Garamond',Georgia,serif";

  var TC_SR_CART_PRODUCT_CSS =
    '#scrollable-item-container-wrapper{background:' +
    TC_SR_BODY_LIGHT +
    '!important;}' +
    '.mini-cart-item{background:#fff!important;border:1px solid rgba(74,47,35,.14)!important;' +
    'border-radius:2px!important;box-shadow:none!important;padding:10px!important;}' +
    '.mini-cart-item-title,.mini-cart-item-title-content{color:' +
    TC_SR_BARK +
    '!important;font-family:' +
    TC_SR_FONT_DISPLAY +
    '!important;font-weight:500!important;font-size:1.35rem!important;' +
    'line-height:1.3!important;text-transform:none!important;letter-spacing:-.01em!important;}' +
    '.mini-cart-item-variant,.mini-cart-item-qty-container{font-family:' +
    TC_SR_FONT_BODY +
    '!important;color:' +
    TC_SR_MUTED +
    '!important;}' +
    '.mini-cart-item-price,.mini-cart-item-quantity,[class*="sr-cart-item-price"]{font-family:' +
    TC_SR_FONT_BODY +
    '!important;color:' +
    TC_SR_BARK +
    '!important;font-weight:600!important;}' +
    '[class*="sr-cart-item-cut-out-price"]{color:' +
    TC_SR_MUTED +
    '!important;font-weight:400!important;text-decoration:line-through!important;}' +
    '.sr-cart-item-image-container{min-width:72px!important;min-height:90px!important;margin-top:0!important;}' +
    '.sr-cart-item-image,.mini-cart-item img{width:72px!important;max-height:96px!important;height:96px!important;' +
    'object-fit:cover!important;object-position:center top!important;border:1px solid rgba(74,47,35,.12)!important;' +
    'border-radius:999px 999px 0 0!important;}' +
    '.sr-cart-item-discount-badge{top:auto!important;bottom:6px!important;left:6px!important;right:auto!important;' +
    'max-width:calc(100% - 12px)!important;border-radius:2px!important;background:' +
    TC_SR_SALE_CHIP_BG +
    '!important;color:' +
    TC_SR_SALE_CHIP_TEXT +
    '!important;font-family:' +
    TC_SR_FONT_BODY +
    '!important;font-size:9px!important;font-weight:600!important;letter-spacing:.12em!important;' +
    'text-transform:uppercase!important;padding:4px 8px!important;}' +
    '.sr-cart-item-image-container .discount-badge{top:auto!important;bottom:4px!important;left:4px!important;' +
    'right:auto!important;width:auto!important;height:auto!important;}' +
    '.mini-cart-item-actions{border-radius:0!important;border:1px solid rgba(74,47,35,.35)!important;' +
    'background:#fff!important;height:24px!important;min-width:76px!important;}' +
    '.mini-cart-item-actions button{color:' +
    TC_SR_BARK +
    '!important;font-family:' +
    TC_SR_FONT_BODY +
    '!important;}' +
    '.similar-items-section{background:transparent!important;border-radius:0!important;margin:8px 10px!important;' +
    'padding:0!important;}' +
    '.similar-item-headings-container{border-bottom-color:rgba(74,47,35,.2)!important;}' +
    '.similar-item-heading,.similar-items-section .similar-item-heading{font-family:' +
    TC_SR_FONT_DISPLAY +
    '!important;color:' +
    TC_SR_BARK +
    '!important;font-weight:500!important;font-size:1.6rem!important;}' +
    '.similar-item-heading.active-heading{border-bottom-color:' +
    TC_SR_BARK +
    '!important;color:' +
    TC_SR_BARK +
    '!important;}' +
    '.similar_item,.similar-item{min-width:128px!important;height:auto!important;min-height:188px!important;' +
    'border:1px solid rgba(74,47,35,.14)!important;border-radius:2px!important;background:#fff!important;' +
    'padding:6px!important;box-shadow:none!important;}' +
    '.similar_item img,.similar-item img{width:100%!important;height:auto!important;aspect-ratio:2/3!important;' +
    'object-fit:cover!important;object-position:center top!important;border:none!important;' +
    'border-radius:999px 999px 0 0!important;display:block!important;}' +
    '.similar-items-title,.sr-upsell-item-name{font-family:' +
    TC_SR_FONT_DISPLAY +
    '!important;color:' +
    TC_SR_BARK +
    '!important;font-weight:500!important;font-size:1.2rem!important;line-height:1.25!important;}' +
    '.similar-items-price,.sr-upsell-item-current-price{font-family:' +
    TC_SR_FONT_BODY +
    '!important;color:' +
    TC_SR_BARK +
    '!important;font-weight:600!important;}' +
    '.sr-upsell-item-original-price,.similar-items-price s{color:' +
    TC_SR_MUTED +
    '!important;font-weight:400!important;}' +
    '.sr-upsell-item-save-amount,.sr-cart-percent-discount-text{color:' +
    TC_SR_BARK +
    '!important;font-family:' +
    TC_SR_FONT_BODY +
    '!important;font-weight:500!important;}' +
    '.sr-upsell-item{border:1px solid rgba(74,47,35,.14)!important;border-radius:2px!important;' +
    'background:#fff!important;box-shadow:none!important;height:auto!important;min-height:88px!important;}' +
    '.sr-upsell-item .product-img{border-radius:999px 999px 0 0!important;object-fit:cover!important;' +
    'object-position:center top!important;border:1px solid rgba(74,47,35,.1)!important;padding:0!important;}' +
    '.sr-upsell-image-wrapper{width:64px!important;height:80px!important;overflow:hidden!important;' +
    'border-radius:999px 999px 0 0!important;}' +
    '.sr-upsell-item-action{border-radius:0!important;border:1px solid ' +
    TC_SR_BARK +
    '!important;color:' +
    TC_SR_BARK +
    '!important;box-shadow:none!important;font-family:' +
    TC_SR_FONT_BODY +
    '!important;font-size:11px!important;background:#fff!important;}' +
    '.combined-offer-badge{background:' +
    TC_SR_BODY_LIGHT +
    '!important;color:' +
    TC_SR_BARK +
    '!important;font-family:' +
    TC_SR_FONT_BODY +
    '!important;animation:none!important;border-bottom:1px solid rgba(74,47,35,.12)!important;}' +
    '.upsell-container-combined{background:transparent!important;border-radius:0!important;margin:8px 10px!important;padding:0!important;}';

  var TC_SR_CART_THEME_CSS =
    ':host{' +
    '--sr-banner-background-color:' +
    TC_SR_BARK +
    '!important;' +
    '--sr-banner-text-color:' +
    TC_SR_ON_BARK +
    '!important;' +
    '--sr-progress-section-bg-color:' +
    TC_SR_BODY_LIGHT +
    '!important;' +
    '--sr-overall-bg-color:' +
    TC_SR_BODY_LIGHT +
    '!important;' +
    '--sr-mini-cart-header-background-color:' +
    TC_SR_BODY_LIGHT +
    '!important;' +
    '--sr-mini-cart-header-text-color:' +
    TC_SR_BARK +
    '!important;' +
    '--sr-mini-cart-header-icon-color:' +
    TC_SR_BARK +
    '!important;' +
    '--sr-mini-cart-primary-color:' +
    TC_SR_BARK +
    '!important;' +
    '}' +
    '.sr-cart-banner-container,#sr-cart-banner{' +
    'background:' +
    TC_SR_BARK +
    '!important;color:' +
    TC_SR_ON_BARK +
    '!important;' +
    '}' +
    '.sr-cart-banner-container a,#sr-cart-banner a{color:' +
    TC_SR_ON_BARK +
    '!important;}' +
    '#mini-cart-progress-section{' +
    'background:' +
    TC_SR_BODY_LIGHT +
    '!important;background-image:none!important;' +
    '}' +
    '#mini-cart-progress-section.tc-sr-progress--hidden{display:none!important;height:0!important;' +
    'min-height:0!important;padding:0!important;margin:0!important;border:none!important;overflow:hidden!important;}' +
    '.mini-cart-header{background-color:' +
    TC_SR_BODY_LIGHT +
    '!important;box-shadow:0 4px 4px rgba(74,47,35,.08)!important;}' +
    '.wrapper-mini-cart-sr{background-color:' +
    TC_SR_BODY_LIGHT +
    '!important;}' +
    '#sr-buy-now-button{' +
    'background:' +
    TC_SR_BARK +
    '!important;color:' +
    TC_SR_ON_BARK +
    '!important;' +
    'border:1px solid ' +
    TC_SR_BARK +
    '!important;border-radius:0!important;box-shadow:none!important;' +
    '}' +
    '#sr-buy-now-button:hover:not(:disabled){' +
    'background:#3d251c!important;color:' +
    TC_SR_ON_BARK +
    '!important;border-color:#3d251c!important;' +
    '}' +
    '#sr-buy-now-button .buy-now-text-content,' +
    '#sr-buy-now-button .sr-button-text-container{color:inherit!important;}' +
    '.sr-cart-buy-btn-payment-icons{display:inline-block!important;width:auto!important;max-height:1.6rem;}' +
    TC_SR_CART_PRODUCT_CSS;

  function smartCartReady() {
    return Boolean(window.shiprocketSmartCartLoaded);
  }

  function getSmartCartShadowRoot() {
    var host = document.querySelector('[data-app="shiprocket-smart-cart"]');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  var productSaleCache = {};

  function cartLineIsSaleProduct(item) {
    if (!item) {
      return false;
    }
    var unitPrice = item.final_price != null ? item.final_price : item.price;
    if (item.compare_at_price != null && Number(item.compare_at_price) > Number(unitPrice)) {
      return true;
    }
    if (item.original_price != null && Number(item.original_price) > Number(unitPrice)) {
      return true;
    }
    if (item.original_line_price != null && item.final_line_price != null) {
      if (Number(item.original_line_price) > Number(item.final_line_price)) {
        return true;
      }
    }
    if (item.original_line_price != null && item.line_price != null) {
      if (Number(item.original_line_price) > Number(item.line_price)) {
        return true;
      }
    }
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
      return true;
    }
    if (item.discounts && item.discounts.length > 0) {
      return true;
    }
    return false;
  }

  function productVariantOnSale(handle, variantId) {
    var cacheKey = handle + ':' + variantId;
    if (Object.prototype.hasOwnProperty.call(productSaleCache, cacheKey)) {
      return Promise.resolve(productSaleCache[cacheKey]);
    }

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('product');
        }
        return response.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (v) {
          return v.id === variantId;
        });
        if (!variant) {
          productSaleCache[cacheKey] = false;
          return false;
        }
        var compare = parseFloat(variant.compare_at_price, 10);
        var price = parseFloat(variant.price, 10);
        var onSale = !Number.isNaN(compare) && !Number.isNaN(price) && compare > price;
        productSaleCache[cacheKey] = onSale;
        return onSale;
      })
      .catch(function () {
        productSaleCache[cacheKey] = false;
        return false;
      });
  }

  function cartHasSaleProductsAsync(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return Promise.resolve(false);
    }

    if (cart.items.some(cartLineIsSaleProduct)) {
      return Promise.resolve(true);
    }

    return Promise.all(
      cart.items.map(function (item) {
        return productVariantOnSale(item.handle, item.variant_id);
      })
    ).then(function (results) {
      return results.some(Boolean);
    });
  }

  function shadowCartShowsSaleLine() {
    var root = getSmartCartShadowRoot();
    if (!root) {
      return false;
    }
    if (root.querySelector('.sr-cart-item-discount-badge')) {
      return true;
    }
    if (root.querySelector('[class*="sr-cart-item-cut-out-price"]')) {
      return true;
    }
    if (root.querySelector('.discount-badge')) {
      return true;
    }
    return false;
  }

  function fetchCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart');
      }
      return response.json();
    });
  }

  function applyProgressSectionVisibility(hasSale) {
    var root = getSmartCartShadowRoot();
    if (!root) {
      return false;
    }
    var progress = root.getElementById('mini-cart-progress-section');
    if (!progress) {
      return false;
    }
    if (hasSale) {
      if (progress.classList.contains('tc-sr-progress--hidden')) {
        progress.classList.remove('tc-sr-progress--hidden');
      }
    } else if (!progress.classList.contains('tc-sr-progress--hidden')) {
      progress.classList.add('tc-sr-progress--hidden');
    }
    return true;
  }

  var progressSyncPending = null;
  var progressObserverStarted = false;

  function ensureProgressSectionObserver() {
    if (progressObserverStarted) {
      return;
    }
    var root = getSmartCartShadowRoot();
    if (!root) {
      return;
    }
    progressObserverStarted = true;
    var observer = new MutationObserver(function () {
      syncSmartCartProgressSection();
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  function syncSmartCartProgressSection() {
    if (progressSyncPending) {
      return progressSyncPending;
    }
    progressSyncPending = fetchCartState()
      .then(function (cart) {
        return cartHasSaleProductsAsync(cart).then(function (hasSale) {
          if (!hasSale && shadowCartShowsSaleLine()) {
            hasSale = true;
          }
          applyProgressSectionVisibility(hasSale);
          ensureProgressSectionObserver();
        });
      })
      .catch(function () {
        applyProgressSectionVisibility(shadowCartShowsSaleLine());
      })
      .finally(function () {
        progressSyncPending = null;
      });
    return progressSyncPending;
  }

  function injectSmartCartThemeStyles() {
    var host = document.querySelector('[data-app="shiprocket-smart-cart"]');
    if (!host || !host.shadowRoot) {
      return false;
    }
    var style = host.shadowRoot.querySelector('#tc-sr-cart-theme-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tc-sr-cart-theme-styles';
      host.shadowRoot.appendChild(style);
    }
    style.textContent = TC_SR_CART_THEME_CSS;
    return true;
  }

  function scheduleSmartCartThemeStyles() {
    injectSmartCartThemeStyles();
    syncSmartCartProgressSection();
    window.setTimeout(injectSmartCartThemeStyles, 0);
    window.setTimeout(syncSmartCartProgressSection, 0);
    window.setTimeout(injectSmartCartThemeStyles, 400);
    window.setTimeout(syncSmartCartProgressSection, 400);
    window.setTimeout(injectSmartCartThemeStyles, 1200);
    window.setTimeout(syncSmartCartProgressSection, 1200);
  }

  function watchSmartCartShadowStyles() {
    var elapsed = 0;
    var timer = window.setInterval(function () {
      if (injectSmartCartThemeStyles() || elapsed >= SMART_CART_WAIT_MS) {
        window.clearInterval(timer);
      }
      elapsed += SMART_CART_POLL_MS;
    }, SMART_CART_POLL_MS);
  }

  function closeNativeCartModal() {
    if (typeof window.xoModal !== 'undefined' && typeof window.xoModal.close === 'function') {
      window.xoModal.close('cart');
    }
  }

  function waitForSmartCart() {
    return new Promise(function (resolve) {
      if (smartCartReady()) {
        resolve(true);
        return;
      }

      var elapsed = 0;
      var timer = window.setInterval(function () {
        elapsed += SMART_CART_POLL_MS;
        if (smartCartReady()) {
          window.clearInterval(timer);
          resolve(true);
          return;
        }
        if (elapsed >= SMART_CART_WAIT_MS) {
          window.clearInterval(timer);
          resolve(false);
        }
      }, SMART_CART_POLL_MS);
    });
  }

  async function refreshAndOpenSmartCart() {
    var ready = await waitForSmartCart();
    if (!ready) {
      return false;
    }

    closeNativeCartModal();

    try {
      if (typeof window.updateMiniCartSection === 'function') {
        await window.updateMiniCartSection();
      }
    } catch (error) {
      console.warn('[tc-smart-cart] updateMiniCartSection failed', error);
    }

    scheduleSmartCartThemeStyles();

    if (typeof window.slideShiprocketSmartCartInFrame === 'function') {
      window.slideShiprocketSmartCartInFrame();
      scheduleSmartCartThemeStyles();
      return true;
    }

    return false;
  }

  function disableNativeCartAutoOpen() {
    document.querySelectorAll('xo-cart-add:not([xo-cart-opened])').forEach(function (el) {
      el.setAttribute('xo-cart-opened', 'false');
    });
  }

  function observeCartAddElements() {
    disableNativeCartAutoOpen();

    if (typeof MutationObserver === 'undefined') {
      return;
    }

    var observer = new MutationObserver(function () {
      disableNativeCartAutoOpen();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function wireCartLinks() {
    document.querySelectorAll('.tc-header__cart, .toolbar__item[href*="/cart"], a[href="/cart"]').forEach(function (link) {
      if (link.closest('[data-app="shiprocket-smart-cart"]')) {
        return;
      }

      link.setAttribute('data-no-instant', '');

      if (link.pathname && link.pathname.endsWith('/cart')) {
        link.setAttribute('href', '/cart');
      }

      link.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          refreshAndOpenSmartCart();
        },
        true
      );
    });
  }

  function wireModalTriggers() {
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('xo-modal-trigger[xo-name="cart"]');
        if (!trigger) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        refreshAndOpenSmartCart();
      },
      true
    );
  }

  function wireCartSubscribe() {
    if (typeof window.cartSubscribe !== 'function') {
      return;
    }

    var previousSize = null;

    window.cartSubscribe(function (state) {
      syncSmartCartProgressSection();
      if (previousSize !== null && state.size > previousSize) {
        closeNativeCartModal();
        refreshAndOpenSmartCart();
      }
      previousSize = state.size;
    });
  }

  function init() {
    observeCartAddElements();
    wireCartLinks();
    wireModalTriggers();
    wireCartSubscribe();
    watchSmartCartShadowStyles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
